import {Base} from "@/api/Base"

export class EmployeeQuit extends Base {
    path = "employee/quit"
}